import { selectCurrentTovar, selectDefaults } from "./leadReducer";
const commonPodushka = require("../../../back/src/common/podushka/selectors");

export const defaults = (state) => {
  return commonPodushka.getOptions(
    selectDefaults(state),
    selectCurrentTovar(state)
  );
};
